import ApexChart from "../../../../../shared/components/chart/apexChart";
import { SINGLE_ARRAY_LENGTH } from "../../../../../constants";
import {
  reportGraphHeaders,
  MARKETING_ATTRIBUTION_LABELS,
} from "../../../constants/marketingAttribution.constants";

const MarketingAttributionChart = ({
  chartData,
  totalOrders,
  chartOptions,
  borderClassName = "border graph-border rounded p-1",
}) => {
  const hasChartData = chartData.length > SINGLE_ARRAY_LENGTH;

  return (
    <div className="mt-3 bg-white shadow rounded px-md-4 px-2 py-3">
      <div className={`position-relative ${borderClassName}`}>
        {hasChartData ? (
          <>
            <div className="text-center bg-white border position-absolute rounded chart-legend total-Orders end-0 p-2 mx-2 my-1">
              <h6>{reportGraphHeaders.TOTAL_ORDERS}</h6>
              <h6 className="fw-bold">{totalOrders}</h6>
            </div>
            <ApexChart
              options={chartOptions}
              data={chartData}
              width="100%"
              height={250}
            />
          </>
        ) : (
          <p className="p-4 text-center mb-0">
            {MARKETING_ATTRIBUTION_LABELS.NO_DATA_FOUND}
          </p>
        )}
      </div>
    </div>
  );
};

export default MarketingAttributionChart;
